import { createContext } from 'react';

// $FlowFixMe
export var RendererContext = createContext();

// $FlowFixMe
export var ThemeContext = createContext();